import { useLocation, useNavigate } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

import { ErrorState } from '@/components/ui/ErrorState';

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <ErrorState
        icon={<FileQuestion />}
        title="Página não encontrada"
        description={`A rota "${pathname}" não existe ou foi movida.`}
        actions={[
          { label: 'Voltar ao início', onClick: () => navigate('/app', { replace: true }) },
          { label: 'Voltar', onClick: () => navigate(-1 as never), variant: 'outline' },
        ]}
      />
    </div>
  );
}
